<button type="button" class="social-btn google-btn" (click)="loginWithGoogle()">
  <span class="icon"><i class="fa-brands fa-google" aria-hidden="true"></i> </span>
</button>
